<template>
  <div class="wrapper">
    <vxe-modal
      v-model="dialogVisible"
      width="350"
      height="250"
      title="商户余额"
      mask-closable
      esc-closable
      resize
      @close="close"
    >
      <p>
        <span
          style="display: inline-block; width:100px;text-align: right"
        >商户ID:</span>
        <span style="padding-left:5px">{{ parentData.wsMerchantId }}</span>
      </p>
      <p v-for="item in balanceList" :key="item.id">
        <span
          style="display: inline-block; width:100px;text-align: right"
        >{{ balanceType(item.accountType) }}</span>
        <span style="padding-left:5px">{{ item.totalAmount / 100 }}（元）</span>
      </p>
    </vxe-modal>
  </div>
</template>
 
<script>
import { queryBalance } from "@/api/invoice";
export default {
  props:{
    parentData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data(){
    return {
      dialogVisible:false,
      loading:false,
      tableData:[],
      formData: {
        codes:[],
        orderNo:'',
        createdBy :'',
        payReceiptImg:'',
      },
      balanceList: [],
      rules:{
        totalAmount: [
          { required: true, message: "请输入打款金额", trigger: "blur" }
        ],
        orderNo: [
          { required: true, message: "请输入流水号", trigger: "change" },
          { max:64, message:'长度不能超过64个字符'}
        ],
      }
    }
  },
  created(){},
  methods:{
    show(){
      // this.formData = Object.assign({},this.parentData)
      this.dialogVisible = true
      this.findList()
    },
    // 获取/查询 列表
    async findList() {
      const rLoading = this.openLoading();
      let response = await queryBalance(this.parentData.partyCode)
      rLoading.close()
      this.balanceList = response.data;
    },
    // 关闭
    close(){
      this.dialogVisible = false
    },
    
    //商户类型
    balanceType(type) {
      switch (type) {
        case "BALANCE":
          return "商户余额:";
        case "FREEZE":
          return "冻结余额:";
        case "TRADE_DEPOSIT":
          return "保证金余额:";
        default:
          break;
      }
    },
  }
};
</script>